import QRCode from "qrcode";

const BLUE = "#1E7FD4", NAVY = "#14264A", GOLD = "#F5B700", GREY = "#4B5563", DARK = "#1F2937";
const W = 2000, H = 1440;

const loadImg = (src) => new Promise((res) => { const i = new Image(); i.onload = () => res(i); i.onerror = () => res(null); i.src = src; });
const rr = (ctx, x, y, w, h, r) => { ctx.beginPath(); ctx.roundRect(x, y, w, h, r); };
const fmtD = (d) => { if (!d) return "-"; const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(d); return m ? `${m[3]}-${m[2]}-${m[1]}` : d; };

export const cardQrText = (c) => [
  "PATIENT SHIPMENT DOCUMENTATION",
  `Patient Name: ${c.patient_name || "-"}`,
  `Company Name: ${c.company_name || "-"}`,
  `Processed By: ${c.processed_by || "-"}`,
  `Product Name: ${c.product_name || "-"}`,
  `Total Product Quantity: ${c.total_quantity || "-"}`,
  "BATCH DETAILS:",
  ...(c.batches || []).map((b, i) => `Batch ${i + 1}: Qty ${b.quantity || "-"} pcs | Batch ${b.batch_number || "-"} | Expiry ${fmtD(b.expiry_date)}`),
  `AWB Number: ${c.awb_number || "-"}`,
  `Dispatch Date: ${fmtD(c.dispatch_date)}`,
  `Mode of Shipping: ${c.mode || "-"}`,
  `Dispatch Origin: ${c.origin || "-"}`,
  `Destination: ${c.destination || "-"}`,
  `Photos URL: ${c.photos_url || "-"}`,
  `Notes: ${c.notes || "-"}`,
].join("\n");

export async function renderPatientCard(c) {
  const canvas = document.createElement("canvas");
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext("2d");
  const [logo, qr] = await Promise.all([loadImg("/heliopolis-logo.png"), QRCode.toDataURL(cardQrText(c), { errorCorrectionLevel: "M", margin: 1, width: 600 }).then(loadImg)]);

  ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = "#E5E7EB"; rr(ctx, 20, 20, W - 40, H - 40, 26); ctx.fill();
  ctx.fillStyle = "#fff"; rr(ctx, 24, 24, W - 48, H - 48, 24); ctx.fill();
  // header
  ctx.save(); rr(ctx, 24, 24, W - 48, 190, 24); ctx.clip(); ctx.fillStyle = BLUE; ctx.fillRect(24, 24, W - 48, 190); ctx.restore();
  ctx.fillStyle = GOLD; ctx.fillRect(24, 204, W - 48, 16);
  ctx.fillStyle = "#fff"; rr(ctx, 56, 44, 344, 130, 18); ctx.fill();
  if (logo) { const r = Math.min(300 / logo.width, 100 / logo.height); const lw = logo.width * r, lh = logo.height * r; ctx.drawImage(logo, 56 + (344 - lw) / 2, 44 + (130 - lh) / 2, lw, lh); }
  ctx.fillStyle = "#fff"; ctx.font = "bold 56px Arial"; ctx.fillText("PATIENT SHIPMENT DOCUMENTATION", 448, 108);
  ctx.font = "26px Arial"; ctx.fillText("Product traceability • shipment details • photo documentation", 448, 152);
  ctx.fillStyle = "#fff"; rr(ctx, 1512, 56, 418, 106, 14); ctx.fill();
  ctx.fillStyle = GREY; ctx.font = "20px Arial"; ctx.fillText("DOCUMENT REFERENCE", 1540, 90);
  ctx.fillStyle = BLUE; ctx.font = "bold 26px Arial"; ctx.fillText(c.doc_ref || "", 1540, 132);

  // left panel
  ctx.fillStyle = "#F5F7FA"; rr(ctx, 60, 252, 1036, 870, 22); ctx.fill(); ctx.strokeStyle = "#E5E7EB"; ctx.lineWidth = 3; ctx.stroke();
  const section = (title, y) => { ctx.fillStyle = GOLD; ctx.fillRect(90, y - 30, 14, 34); ctx.fillStyle = BLUE; ctx.font = "bold 34px Arial"; ctx.fillText(title, 124, y); ctx.fillStyle = "#D1D5DB"; ctx.fillRect(90, y + 20, 970, 3); };
  const row = (label, value, y) => { ctx.fillStyle = GREY; ctx.font = "bold 26px Arial"; ctx.fillText(label, 90, y); ctx.fillStyle = BLUE; ctx.font = "26px Arial"; ctx.fillText(String(value || "-"), 390, y); };
  section("PATIENT & PRODUCT", 308);
  row("Patient Name", c.patient_name, 378); row("Company Name", c.company_name, 425); row("Processed By", c.processed_by, 472); row("Product Name", c.product_name, 519); row("Total Quantity", c.total_quantity, 566);
  section("BATCH / EXPIRY BREAKDOWN", 620);
  ctx.fillStyle = GREY; ctx.font = "bold 26px Arial"; ["#", "Qty", "Batch Number", "Expiry", "Status"].forEach((h, i) => ctx.fillText(h, [90, 175, 360, 665, 860][i], 670));
  ctx.fillStyle = "#D1D5DB"; ctx.fillRect(90, 684, 970, 2);
  (c.batches || []).slice(0, 4).forEach((b, i) => { const y = 720 + i * 44; ctx.fillStyle = BLUE; ctx.font = "26px Arial"; ctx.fillText(String(i + 1), 90, y); ctx.fillText(String(b.quantity || "-"), 175, y); ctx.fillText(b.batch_number || "-", 360, y); ctx.fillText(fmtD(b.expiry_date), 665, y); ctx.fillStyle = "#15803D"; ctx.fillText("Recorded", 860, y); });
  section("SHIPMENT", 890);
  row("AWB Number", c.awb_number, 950); row("Dispatch Date", fmtD(c.dispatch_date), 991); row("Mode", c.mode, 1032); row("Origin", c.origin, 1073); row("Destination", c.destination, 1114);

  // right panel
  ctx.fillStyle = "#fff"; rr(ctx, 1140, 252, 800, 720, 22); ctx.fill(); ctx.strokeStyle = "#E5E7EB"; ctx.stroke();
  ctx.fillStyle = GOLD; rr(ctx, 1160, 268, 760, 80, 14); ctx.fill();
  ctx.fillStyle = BLUE; ctx.font = "bold 34px Arial"; ctx.fillText("DIGITAL SHIPMENT RECORD", 1190, 320);
  ctx.fillStyle = GREY; ctx.font = "22px Arial"; ctx.fillText("Scan the QR for shipment details and the photo-documentation link.", 1184, 388);
  if (qr) ctx.drawImage(qr, 1256, 430, 566, 566);
  ctx.fillStyle = BLUE; ctx.font = "bold 32px Arial"; ctx.fillText("PHOTO DOCUMENTATION LINK", 1176, 1030);
  ctx.fillStyle = GREY; ctx.font = "22px Arial";
  const url = c.photos_url || "-"; let cut = url; while (ctx.measureText(cut).width > 760 && cut.length > 10) cut = cut.slice(0, -1); ctx.fillText(cut === url ? url : cut + "…", 1176, 1068);

  // notes + footer
  ctx.fillStyle = "#F5F7FA"; rr(ctx, 60, 1190, 1880, 200, 22); ctx.fill(); ctx.strokeStyle = "#E5E7EB"; ctx.stroke();
  ctx.fillStyle = GOLD; ctx.fillRect(60, 1190, 16, 200);
  ctx.fillStyle = BLUE; ctx.font = "bold 36px Arial"; ctx.fillText("NOTES", 96, 1244);
  ctx.font = "28px Arial"; ctx.fillText(c.notes || "No additional notes.", 326, 1244);
  ctx.fillStyle = GREY; ctx.font = "20px Arial"; ctx.fillText(`Issued: ${new Date().toLocaleString("en-GB")}  |  Processed by: ${c.processed_by || "-"}  |  Electronically generated document`, 72, 1416);
  return canvas;
}

export const cardBlob = (canvas) => new Promise((res) => canvas.toBlob(res, "image/png"));
export const cardFileName = (c) => `${(c.patient_name || "PTN").replace(/[^a-z0-9]+/gi, "_")}_${(c.product_name || "").replace(/[^a-z0-9]+/gi, "_")}_${(c.awb_number || "AWB").replace(/[^a-z0-9]+/gi, "_")}_CARD.png`;
